const toString = Object.prototype.toString
// const hasOwn = Object.prototype.hasOwnProperty
const types = {
  '[object Undefined]': 'undefined',
  '[object Boolean]': 'bool',
  '[object Number]': 'number',
  '[object String]': 'string',
  '[object Object]': 'object',
  '[object Array]': 'array',
  '[object Function]': 'function',
  '[object Date]': 'date',
  '[object RegExp]': 'regExp'
}
function type(obj) {
  return obj === null ? String(obj) : types[toString.call(obj)] || 'object'
}

export const isNil = (data) => {
  return data === undefined || data === null || isNaN(data)
}

export const isEmptyArray = data => data && !data.length

// false: '' undefined null
// true: 0 '0'
export const isExist = data => !!data || data === 0

export const isPlainObject = (value) => {
  return type(value) === 'object'
}

export const isArray = value => type(value) === 'array'

export const isNumber = value => type(value) === 'number'

export const isString = value => type(value) === 'string'
